import {
  createRouter,
  createRoute,
  createRootRoute,
  lazyRouteComponent,
  Outlet,
} from "@tanstack/react-router";
import App from "./App";
import Home from "./components/Home";
import Projects from "./components/Projects";
import Packages from "./components/Packages";
import Articles from "./components/Articles";
import ArticlePage from "./components/ArticlePage";
import { ARTICLE_CATEGORIES, type ArticleCategory } from "./lib/articles";
// import SignIn from "./components/SignIn";
// import SignUp from "./components/SignUp";

// Create the root route: Outlet only, so /play can sit outside the App shell
const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

// Pathless layout keeps every classic URL and its DOM unchanged
const classicLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "_classic",
  component: App,
});

const playRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/play",
  component: lazyRouteComponent(() => import("./game/GamePage")),
});

// Create routes
const indexRoute = createRoute({
  getParentRoute: () => classicLayoutRoute,
  path: "/",
  component: Home,
});

const projectsRoute = createRoute({
  getParentRoute: () => classicLayoutRoute,
  path: "/projects",
  component: Projects,
});

const packagesRoute = createRoute({
  getParentRoute: () => classicLayoutRoute,
  path: "/packages",
  component: Packages,
});

const articlesRoute = createRoute({
  getParentRoute: () => classicLayoutRoute,
  path: "/articles",
  validateSearch: (
    s: Record<string, unknown>
  ): { category?: ArticleCategory } => ({
    category: ARTICLE_CATEGORIES.find((c) => c === s.category),
  }),
  component: Articles,
});

const articleRoute = createRoute({
  getParentRoute: () => classicLayoutRoute,
  path: "/articles/$slug",
  component: ArticlePage,
});

// const signInRoute = createRoute({
//   getParentRoute: () => rootRoute,
//   path: "/signin",
//   component: SignIn,
// });

// const signUpRoute = createRoute({
//   getParentRoute: () => rootRoute,
//   path: "/signup",
//   component: SignUp,
// });

// Create the route tree
const routeTree = rootRoute.addChildren([
  classicLayoutRoute.addChildren([
    indexRoute,
    projectsRoute,
    packagesRoute,
    articlesRoute,
    articleRoute,
  ]),
  playRoute,
  // signInRoute,
  // signUpRoute,
]);

// Create the router
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Export the router instance
export default router;
